import { stripHtml } from "string-strip-html";

export const copyHtmlOfElement = (element: InnerHTML): void => {
  const listener = (ev: ClipboardEvent): void => {
    const plainText = stripHtml(element.innerHTML).result;
    const htmlWithBreaks = element.innerHTML.replace(/\n/g, "<br>");
    ev.clipboardData?.setData("text/html", htmlWithBreaks);
    ev.clipboardData?.setData("text/plain", plainText);
    ev.preventDefault();
  };
  document.addEventListener("copy", listener);
  // TODO `execCommand` is deprecated. [MDN Reference](https://developer.mozilla.org/docs/Web/API/Document/execCommand)
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  document.execCommand("copy");
  document.removeEventListener("copy", listener);
};

export const copyStringToClipboard = (text: string): void => {
  const listener = (ev: ClipboardEvent): void => {
    ev.clipboardData?.setData("text/plain", text);
    ev.preventDefault();
  };
  document.addEventListener("copy", listener);
  // TODO `execCommand` is deprecated. [MDN Reference](https://developer.mozilla.org/docs/Web/API/Document/execCommand)
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  document.execCommand("copy");
  document.removeEventListener("copy", listener);
};
